import { KYMW1406Model } from '../kymw1406.model';
import { RequestUpdateGoodsInfoModel } from '../../kymw1400/vo/request-update-goods-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品情報を更新する。
 *
 * @export
 * @class UpdateGoodsInfoService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class UpdateGoodsInfoService extends PlessJsonResponderSub<any> {

  private model: KYMW1406Model = null;
  private vo: RequestUpdateGoodsInfoModel = null;
  private successFunc: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateGoodsInfoService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.goodsInfoList.map((gi, i) => {
      const ogfk = this.vo.orderGoodsFlgKoma[i];
      return {
        parameter: {
          PCode: gi.pCode,
          OrderNumSeqNo: gi.orderNumSeqNo,
          Priority: gi.priority
        },
        condition: {
          Pcode: this.vo.pcodeList[i],
          pCode: ogfk.PCode,
          OrderGoodsFlg: ogfk.OrderGoodsFlg
        }
      };
    });

    return new PlessRequest({
      update: {
        GoodsInfo: {
          parameter: {
            KomaID: this.vo.komaID,
            ListingPatternID: this.vo.listingPatternID,
            ListingPCode: this.vo.listingPCode,
            KomaComment: this.vo.komaComment,
            KomaPatternDiv: this.vo.komaPatternDiv,
            ValueKomaComment: this.vo.valueKomaComment,
            OrderGoodsFlg: this.vo.orderGoodsFlg,
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            CrossCode: this.vo.crossCode,
            CrossGoodsExplanation: this.vo.crossGoodsExplanation,
            CrossCatchCopy: this.vo.crossCatchCopy,
            MultiCode: this.vo.multiCode,
            MultiGoodsExplanation: this.vo.multiGoodsExplanation,
            MultiCatchCopy: this.vo.multiCatchCopy
          },
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1406Model} model
   * @param {RequestUpdateGoodsInfoModel} vo
   * @memberof UpdateGoodsInfoService
   */
  execute(model: KYMW1406Model, vo: RequestUpdateGoodsInfoModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updateGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof UpdateGoodsInfoService
   */
  success(_: any) {
    // 親画面を更新する
    this.model.refreshKYMW1400();
    if (this.successFunc) this.successFunc();
  }
}
